import { CheckInFormState } from '@/experiences/sales-portal/domain/accounts/screens/account-detail/containers/account-detail-check-in/types';
import { CheckInTag } from '@/experiences/sales-portal/domain/accounts/screens/account-detail/containers/account-detail-check-in/constants';
import { DateTimeSelection } from '@/experiences/sales-portal/blocs/utils/date-picker-calendar-utils';
import { useState } from 'react';

const INITIAL_FORM_STATE: CheckInFormState = {
  note: '',
  tags: [],
};

/**
 * Holds the local form state for the check-in form.
 * `canSave` is true when the rep selects at least one tag.
 */
export const useCheckInForm = () => {
  const [form, setForm] = useState<CheckInFormState>(INITIAL_FORM_STATE);

  const toggleTag = (tag: CheckInTag) => {
    setForm((prev) => ({
      ...prev,
      tags: prev.tags.includes(tag)
        ? prev.tags.filter((selected) => selected !== tag)
        : [...prev.tags, tag],
    }));
  };

  const setNote = (note: string) => {
    setForm((prev) => ({ ...prev, note }));
  };

  const setReminder = (reminder?: DateTimeSelection) => {
    setForm((prev) => ({ ...prev, reminder }));
  };

  const reset = () => {
    setForm(INITIAL_FORM_STATE);
  };

  const canSave = form.tags.length > 0;

  return { canSave, form, reset, setNote, setReminder, toggleTag };
};
